<template>
  <!-- Main Sidebar Container menu-box-view-->
  <aside class="main-sidebar sidebar-dark-primary">
    <!-- Brand Logo -->

    <router-link to="/" class="brand-link">
      <!-- mini logo for sidebar mini -->
      <span class="logo-mini"
        ><img :src="getImage('logo-mini.svg')" alt="Dotlines"
      /></span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><img :src="getImage('logo.svg')" alt="Dotlines" /></span>
      <!-- <span class="brand-text font-weight-light">Dotlines</span> -->
      <i
        class="far fa-times-circle d-block d-sm-none push-menu-class"
        data-widget="pushmenu"
      ></i>
    </router-link>
    <!-- Sidebar -->

    <div class="sidebar">
      <el-menu
        :router="true"
        default-active="2"
        :unique-opened="true"
        class="sidebar-menu"
        @open="handleOpen"
        @close="handleClose"
      >
        <template
          v-for="(item, index) in menuItems"
          v-if="!ignore_route.includes(item.title)"
        >
          <template v-if="!_.isEmpty(item.uri) && _.isEmpty(item.children)">
            <el-menu-item :index="'/admin/' + (item.uri == '/' ? '' : item.uri)">
              <i
                v-if="!_.isEmpty(item.icon)"
                class="fas icon-menu"
                v-bind:class="item.icon"
              ></i>
              <i v-else class="el-icon-s-help"></i>
              <span> {{ item.title }}</span>
            </el-menu-item>
          </template>
          <template v-else>
            <el-submenu :index="index.toString()">
              <template slot="title">
                <i
                  v-if="!_.isEmpty(item.icon)"
                  class="fas icon-menu"
                  v-bind:class="item.icon"
                ></i>
                <span> {{ item.title }}</span>
              </template>
              <template v-if="!_.isEmpty(item.children)">
                <template
                  v-for="(itemChild, childIndex) in item.children"
                  v-if="!ignore_route.includes(itemChild.title)"
                >
                  <template
                    v-if="!_.isEmpty(itemChild.uri) && _.isEmpty(itemChild.children)"
                  >
                    <el-menu-item :index="'/admin/' + itemChild.uri">
                      <i
                        v-if="!_.isEmpty(itemChild.icon)"
                        class="fas"
                        v-bind:class="itemChild.icon"
                      ></i>
                      <i v-else class="el-icon-s-help"></i>
                      <span> {{ itemChild.title }}</span>
                    </el-menu-item>
                  </template>
                  <template v-else>
                    <el-submenu :index="index.toString() + '-' + childIndex.toString()">
                      <template slot="title">
                        <i
                          v-if="!_.isEmpty(itemChild.icon)"
                          class="fas"
                          v-bind:class="itemChild.icon"
                        ></i>
                        <i v-else class="el-icon-s-help"></i>
                        {{ itemChild.title }}</template
                      >
                      <template
                        v-for="(itemGrandChild, grandChildIndex) in itemChild.children"
                      >
                        <el-menu-item :index="'/admin/' + itemGrandChild.uri">
                          <i
                            v-if="!_.isEmpty(itemGrandChild.icon)"
                            class="fas"
                            v-bind:class="itemGrandChild.icon"
                          ></i>
                          <i v-else class="el-icon-s-help"></i>
                          {{ itemGrandChild.title }}
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                </template>
              </template>
            </el-submenu>
          </template>
        </template>
      </el-menu>
    </div>

    <!-- /.sidebar -->
  </aside>
</template>

<script>
import { CommonAPI, Menu } from "@/services/api";
import LocalStorage from "@/services/localStorage";

export default {
  props: ["menuItems"],
  data: () => ({
    user: {},
    // menuItems: [],
    ignore_route: [
      "Helpers",
      "Templates Settings",
      "Database Connections",
      "Manage Services",
      "Product Management",
      "Manage CSS Class",
      "Transaction Logs",
      "Redis Manager",
      "Manage Box Style",
      "Table Options",
      "Manage Form Setting",
      "App Builder",
      "App Build",
    ],
  }),
  async mounted() {
    $(window).trigger("resize");
    // await this.getAuthDetail();
    // await this.getMenuItems();
    /* let SELECTOR_DATA_WIDGET = '[data-widget="treeview"]';
        let SELECTOR_LINK = '.nav-link';
        let Default = {
          trigger: SELECTOR_DATA_WIDGET + " " + SELECTOR_LINK,
          animationSpeed: 300,
          accordion: true,
          expandSidebar: false,
          sidebarButtonSelector: '[data-widget="pushmenu"]'
        } */
    /* $('[data-widget="treeview"]').each(function() {
          AdminLte.Treeview._jQueryInterface.call($(this), 'init');
        }); */
    // window.$('ul[data-widget="treeview"]').Treeview("init");

    /* const $ = window.$;
        $('[data-widget="treeview"]').each(function() {
          AdminLte.Treeview('init');
        }); */
    /* const $ = window.$;
        const trees = $('[data-widget="treeview"]');
        trees.Treeview('init'); */

    // jQuery('[data-widget="treeview"]').Treeview('init');
    // console.log(jQuery);
    // jQuery('.sidebar-toggle-btn').pushMenu(options)
  },
  methods: {
    /* getAuthDetail: function () {
          let _this = this;
          return new Promise((resolve, reject) => {
            axios
              .get("/auth/get-user")
              .then((response) => {
                _this.user = response.data;
                resolve(response.data);
              })
              .catch((error) => {
                console.log("error " + error);
                reject(error);
              });
          });
        }, */

    getMenuItems: function () {
      const _this = this;
      // console.log('getMenuItems')

      CommonAPI.getApplicationId(LocalStorage.get("deviceType"))
        .then((response) => {
          Menu.getAllMenus(response.applicationId, LocalStorage.get("version")).then(
            (menus) => {
              this.menuItems = menus;
            }
          );
        })
        .catch((error) => {
          // if (error.message == "Unauthenticated.") {
          //   this.$store.dispatch("logout");
          //   this.$router.push("/login");
          // } else {
          //   reject(error);
          // }

          this.$store.dispatch("logout");
          this.$router.push("/login");
          reject(error);
        });
    },
    logout: function () {
      localStorage.setItem("authenticate", false);
      localStorage.removeItem("token");
      this.$router.push({ name: "Login" });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
};
</script>
